import React, {Component} from 'react'

import ErrorNotice from '../error-catcher/error-notice'

const withData = WrappedComponent => {
  return class extends Component {
    static get displayName() {
      const name = WrappedComponent.displayName ||
        WrappedComponent.name || 'Component';
      return `WithData(${name})`;
    }

    state = {
      response: {},
      error: false
    };

    componentDidMount() {
      this.update();
    }

    componentDidUpdate(prevProps) {
      if (this.props.getData !== prevProps.getData ||
        this.props.params !== prevProps.params) {
        this.update();
      }
    }

    update() {
      const {getData, setPreloaderState, params} = this.props;

      if (params !== null) {
        setPreloaderState(true);
        getData(params)
          .then(response => {
            this.setState({
              response
            });

            if (params !== 'page=1&sortBy=popularity') {
              setPreloaderState(false)
            }
          })
          .catch(err => {
            console.error(err);
            this.setState({
              error: true
            })
          })
      }
    }

    render() {
      const {response, error} = this.state;

      if (error) {
        return <ErrorNotice/>
      }

      return (
        <WrappedComponent {...this.props} response={response}/>
      )
    }

  }
};

export default withData;
